import { render } from "./ScoringContacts.vue?vue&type=template&id=599905e8"
import script from "./ScoringContacts.vue?vue&type=script&lang=js"
export * from "./ScoringContacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__